import { Box, Divider } from "@mui/material";
import { TransForm } from "../../common/TransForm/Index";
import { PageTitle } from "../../common/PageTitle";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import _ from "lodash";
import { useCallback, useEffect } from "react";
import axios from "axios";
import { base_url } from '../../backendurl/url'
import { useState } from "react";
import receiptsInvoicesFormInputs from "../../common/jsons/formConfigs/receiptInvoicesFormInput";
import ModalPopUp from "../../common/TransForm/ModalPopUp";
import { Notification } from "../../common/Notification";
import { Config } from "../../../utils/commonFuctions/Token";
import { RefreshToken } from "../../../utils/commonFuctions/RefreshToken";

export const ReceiptInvoices = ({ mode, title }) => {
  const { selectedUser } = useSelector(
    (state) => state
  );
  const [popup, setPopup] = useState(false)
  const { user_uuid } = useParams("user_uuid");
  const [loading, setLoading] = useState(false)
  const [receiptsConfig, setReceiptsConfig] = useState({})
  const [isupdate, setIsupdate] = useState(false)
  const [configData, setConfigData] = useState()
  const [notification, setnotification] = useState(false)
  const [successNotification, setSuccessNotification] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  console.log(receiptsConfig, "receiptsConfig")

  const SubmitConfig = async () => {
    try {
      // Prepare bulk update payload
      const bulkUpdatePayload = {
        configurations: [
          {
            config_type: "transaction_fee",
            value: parseFloat(configData.transaction_fee)
          },
          {
            config_type: "vat", 
            value: parseFloat(configData.vat)
          }
        ]
      };

      await axios.put(`${base_url}/api/accounts/config/bulk-update/`, bulkUpdatePayload, Config);
      
      setPopup(false);
      setSuccessMessage('Configuration updated successfully');
      setSuccessNotification(true);
      
      // Refresh the data to show updated values
      await getReceiptsConfig();
      
    } catch(error) {
      RefreshToken(error, setErrorMessage, setnotification);
    }
  }

  const onSubmit = async (data) => {
    // Convert percentage values to numbers
    data.transaction_fee = typeof data.transaction_fee === 'string' ? parseFloat(data.transaction_fee) : data.transaction_fee
    data.vat = typeof data.vat === 'string' ? parseFloat(data.vat) : data.vat
    
    // Validation for percentage values (0-100)
    if (data.transaction_fee < 0 || data.transaction_fee > 100) {
      setErrorMessage('Transaction Fee should be between 0% and 100%')
      setnotification(true)
      return
    }
    
    if (data.vat < 0 || data.vat > 100) {
      setErrorMessage('VAT should be between 0% and 100%')
      setnotification(true)
      return
    }

    delete data.Add
    
    setPopup(true)
    setnotification(false)
    setConfigData(data)
  };

  // Helper function to transform API response to form data
  const transformApiDataToFormData = (apiData) => {
    const formData = {};
    
    if (apiData.configurations && Array.isArray(apiData.configurations)) {
      apiData.configurations.forEach(config => {
        if (config.config_type === 'transaction_fee') {
          formData.transaction_fee = parseFloat(config.value);
        } else if (config.config_type === 'vat') {
          formData.vat = parseFloat(config.value);
        }
      });
    }
    
    return formData;
  };

  const getReceiptsConfig = useCallback(async () => {
    try {
      if (!loading) {
        setLoading(true)
        const response = await axios.get(`${base_url}/api/accounts/config/`, Config);
        console.log(response?.data, "configresponse")
        
        if (response?.data?.status === 'Success') {
          console.log(response.data.data, "configresponse123")
          
          // Transform the API data to match form structure
          const transformedData = transformApiDataToFormData(response.data.data);
          setReceiptsConfig(transformedData);
          setIsupdate(true)
        } else if (response.data.configurations && response.data.configurations.length === 0) {
          setIsupdate(false)
        }
        setLoading(false)
      }
    } catch(error) {
      setLoading(false)
      RefreshToken(error, setErrorMessage, setnotification)  
    }
  }, [selectedUser, user_uuid, loading]);

  useEffect(() => {
    getReceiptsConfig();
  }, []);

  return (
    <Box>
      <Box sx={{ px: 6, pt: 3 }} alignContent="center">
        <PageTitle pageTitle={'Receipts and Invoices Configuration'} />
      </Box>
      <Divider sx={{ mb: 2, height: 4 }} />
      <TransForm
        submitAction={onSubmit}
        data={receiptsConfig}
        mode={mode}
        cardlength={'twoCard'}
        formInputs={receiptsInvoicesFormInputs({ mode, isupdate })}
      />
      <ModalPopUp
        openpopup={popup}
        setPopup={setPopup}
        title={'Confirm the action ?'}
        subTitle={'Are you sure, you want to update receipts and invoices configuration with given details.'}
        onClick={SubmitConfig}
        save={'Yes, Update'}
        cancel={'Exit'}
      />
      <Notification 
        message={errorMessage} 
        setopen={setnotification} 
        type={'error'} 
        show={notification} 
      />
      <Notification 
        message={successMessage} 
        setopen={setSuccessNotification} 
        type={'success'} 
        show={successNotification} 
      />
    </Box>
  );
};